import React from 'react';
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();

  return (
    <div className="container flex px-4 py-4 text-lg font-medium">
      <p className="mx-auto">{t('text.about')}</p>
    </div>
  );
}

export default About;
